import { useEffect, useState } from "react";
import api from "../lib/api";
import Sidebar from "../components/Sidebar";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import { Calendar, MapPin, Clock, CheckCircle2, XCircle, AlertCircle, FileDown } from "lucide-react";

export default function Bookings() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const load = async () => {
    const { data } = await api.get("/bookings");
    setRows(data);
  };
  useEffect(() => { load(); }, []);

  const downloadInvoice = async (bookingId) => {
    try {
      const res = await api.get(`/bookings/${bookingId}/invoice.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `facture-${bookingId.slice(0, 8)}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert("Téléchargement impossible: " + (e.response?.data?.detail || e.message));
    }
  };

  return (
    <div className="flex bg-[#F7F8F6] min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="max-w-5xl mx-auto p-6 lg:p-10">
          <h1 className="text-3xl sm:text-4xl font-medium tracking-tight mb-2" style={{ fontFamily: "Outfit" }}>{t("bookings.title")}</h1>
          <p className="text-sm text-[#6B726A] mb-8">{t("bookings.subtitle")}</p>

          {rows.length === 0 ? (
            <div className="rp-card p-12 text-center text-sm text-[#6B726A]">
              {t("bookings.empty")}
            </div>
          ) : (
            <div className="space-y-3">
              {rows.map((b) => {
                const Status = {
                  pending:   { Icon: AlertCircle,  label: t("bookings.pending"),   tint: "#C97A20", bg: "#FBEFDA" },
                  confirmed: { Icon: CheckCircle2, label: t("bookings.confirmed"), tint: "#1A4D2E", bg: "#E8F0EA" },
                  refused:   { Icon: XCircle,      label: t("bookings.refused"),   tint: "#E3655B", bg: "#FFF4F3" },
                  cancelled: { Icon: XCircle,      label: "Annulée",               tint: "#E3655B", bg: "#FDE4E2" },
                  completed: { Icon: CheckCircle2, label: "Terminée",              tint: "#3F2EB2", bg: "#E8E5FF" },
                  accepted:  { Icon: CheckCircle2, label: "Acceptée",              tint: "#1E3A8A", bg: "#DBEAFE" },
                }[b.status] || { Icon: AlertCircle, label: b.status, tint: "#6B726A", bg: "#F0F2EF" };
                return (
                  <div key={b.id} className="rp-card p-5 flex flex-col sm:flex-row gap-4 sm:items-center" data-testid={`booking-${b.id}`}>
                    <div className="flex-1 min-w-0">
                      <div className="font-medium">{user.role === "pharmacy" ? b.replacement_name : b.pharmacy_name}</div>
                      <div className="text-xs text-[#6B726A] mb-2">{b.need_snapshot?.role_type}</div>
                      <div className="grid sm:grid-cols-3 gap-2 text-sm text-[#1f2421]">
                        <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-[#6B726A]" />{b.need_snapshot?.start_date}</span>
                        <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[#6B726A]" />{b.need_snapshot?.start_time} – {b.need_snapshot?.end_time}</span>
                        <span className="flex items-center gap-1.5 truncate"><MapPin className="w-3.5 h-3.5 text-[#6B726A]" />{b.need_snapshot?.address}</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full font-medium" style={{ background: Status.bg, color: Status.tint }}>
                        <Status.Icon className="w-3.5 h-3.5" /> {Status.label}
                      </span>
                      {b.status === "confirmed" && (
                        <button onClick={() => downloadInvoice(b.id)}
                          data-testid={`invoice-${b.id}`}
                          title="Télécharger la facture"
                          className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full font-medium border border-[#1A4D2E] text-[#1A4D2E] hover:bg-[#E8F0EA]">
                          <FileDown className="w-3.5 h-3.5" /> Facture
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
